import React from "react";
import "./styles/Exc.css";
import image1 from "../Images/workouts/bb/bb1.1.png";
import image2 from "../Images/workouts/bb/bb1.2.png";
import image3 from "../Images/workouts/bb/bb2.1.png";
import image4 from "../Images/workouts/bb/bb2.2.png";
import image5 from "../Images/workouts/bb/bb3.1.png";
import image6 from "../Images/workouts/bb/bb3.2.png";
import image7 from "../Images/workouts/bb/bb4.1.png";
import image8 from "../Images/workouts/bb/bb4.2.png";
import image9 from "../Images/workouts/bb/bb5.1.png";
import image10 from "../Images/workouts/bb/bb5.2.png";
function Exb() {
  return (
    <>
     
     <div class="card mb-3" id="cardss">
         <div class="row g-0" id="Card1">
          <div class="col-md-4">
            <img src={image1} class="img-fluid rounded-start" id="workouts" alt="" />
          </div>
          <div class="col-md-4">
            <img src={image2} class="img-fluid rounded-start" id="workouts" alt="" />
          </div>
          <div class="col-md-8">
            <div class="card-body" id="cardB">
              <h5 class="card-title">1. Pull-up</h5>
              <p class="card-text">
              Sets 5 Reps 6-10 Tempo 2011 Rest 60sec Hold a pull-up bar with an overhand grip, hands shoulder-width apart. Brace your core, then pull yourself up until your lower chest touches the bar. Lower until your arms are straight again.
              </p>
              <p class="card-text">
                
              </p>
            </div>
          </div>
        </div>
      </div>
     <div class="card mb-3" id="cardss">
         <div class="row g-0" id="Card1">
          <div class="col-md-4">
            <img src={image3} class="img-fluid rounded-start" id="workouts" alt="" />
          </div>
          <div class="col-md-4">
            <img src={image4} class="img-fluid rounded-start" id="workouts" alt="" />
          </div>
          <div class="col-md-8">
            <div class="card-body" id="cardB">
              <h5 class="card-title">2. Bent-over row</h5>
              <p class="card-text">
              Sets 5 Reps 10 Tempo 2010 Rest 60sec Hold a barbell using an overhand grip, hands just outside your legs, and lean forward from the hips. Bend your knees slightly and brace your core, then pull the bar up, leading with your elbows. Lower it back to the start.
              </p>
              <p class="card-text">
               
              </p>
            </div>
          </div>
        </div>
      </div>
     <div class="card mb-3" id="cardss">
         <div class="row g-0" id="Card1">
          <div class="col-md-4">
            <img src={image6} class="img-fluid rounded-start" id="workouts" alt="" />
          </div>
          <div class="col-md-4">
            <img src={image5} class="img-fluid rounded-start" id="workouts" alt="" />
          </div>
          <div class="col-md-8">
            <div class="card-body" id="cardB">
              <h5 class="card-title">3. Chin-up</h5>
              <p class="card-text">
              Sets 3 Reps 6-10 Tempo 2011 Rest 60sec Hold a pull-up bar with hands shoulder-width apart, palms facing you. Brace your core, then pull yourself up until your chin is over the bar. Lower until your arms are straight again.
              </p>
              <p class="card-text">
               
              </p>
            </div>
          </div>
        </div>
      </div>
     <div class="card mb-3" id="cardss">
         <div class="row g-0" id="Card1">
          <div class="col-md-4">
            <img src={image9} class="img-fluid rounded-start" id="workouts" alt="" />
          </div>
          <div class="col-md-4">
            <img src={image10} class="img-fluid rounded-start" id="workouts" alt="" />
          </div>
          <div class="col-md-8">
            <div class="card-body" id="cardB">
              <h5 class="card-title">4. Standing biceps curl</h5>
              <p class="card-text">
              Sets 3 Reps 12-15 Tempo 2011 Rest 60sec Stand with dumbbells by your sides, palms facing forwards. Keeping your elbows tucked in, curl the weights up, squeezing your biceps at the top. Lower them back to the start.
              </p>
              <p class="card-text">
                
              </p>
            </div>
          </div>
        </div>
      </div>
     <div class="card mb-3" id="cardss">
         <div class="row g-0" id="Card1">
          <div class="col-md-4">
            <img src={image7} class="img-fluid rounded-start" id="workouts" alt="" />
          </div>
          <div class="col-md-4">
            <img src={image8} class="img-fluid rounded-start" id="workouts" alt="" />
          </div>
          <div class="col-md-8">
            <div class="card-body" id="cardB">
              <h5 class="card-title">5 Seated incline curl</h5>
              <p class="card-text">
              Sets 3 Reps 12-15 Tempo 2011 Rest 60sec Sit on an incline bench with dumbbells by your sides, palms facing forwards. Keeping your elbows tucked in, curl the weights up, squeezing your biceps at the top. Lower them back to the start.
              </p>
              <p class="card-text">
                
              </p>
            </div>
          </div>
        </div>
      </div>
      
    </>
  );
}

export default Exb;
